export default "8d5bd9f58d3cbe8bb1fb0a42e60251e3.png";